<template>
    <b-modal id="medicineCompanySearch" :title="title" size="md">
        <div class="table_list">
            <ul class="search_filter">
                <li>
                    <p>{{ searchName }}</p>
                    <input type="text" :placeholder="`${searchName}을(를) 입력하세요`" class="form_control" v-model="medHubNm" @keyup.enter="fn_search">
                    <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
                </li>
            </ul>
            <div class="modal_table">
                <table class="list">
                    <colgroup>
                        <col width="10">
                        <col width="50">
                        <col width="50">
                        <col width="50">
                        <col width="50">
                    </colgroup>
                    <thead>
                        <tr>
                            <th></th>
                            <th>No</th>
                            <th>약재명</th>
                            <th>제약회사</th>
                            <th>원산지</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr v-if="medicineList.length == 0">
                        <td colspan="5"><span>데이터가 없습니다.</span></td>
                    </tr>
                    <tr v-for="(item, index) in medicineList" :key="index">
                        <td>
                            <div class="form_checkbox">
                                <input type="checkbox" :id="'checkbox'+index" name="checkbox" v-model="checkBox" :value="index" @change="fn_check">
                                <label :for="'checkbox'+index"></label>
                            </div>
                        </td>
                        <td><span>{{ index + 1 }}</span></td>
                        <td><span>{{ item.med_hrb_nm }}</span></td>
                        <td class="al"><span>{{ item.company_nm }}</span></td>
                        <td class="al"><span>{{ item.org_plce_nm }}</span></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <template #modal-footer="{ ok }">        
            <b-button class="btn btn_md btn_gray" v-show="oneBtn" @click="fn_apply">{{ btnLeft }}</b-button>
            <b-button class="btn btn_md btn_deepblue" @click="fn_init(),ok()">{{ btnRight }}</b-button>
        </template>
    </b-modal>

</template>

<script>
    import axios from 'axios'

    export default {
        name: 'medicineCompanySearch',
        props: {
            title: String,
            btnLeft: String,
            btnRight: String,
            searchName: String,
            searchData: String,
            oneBtn: Boolean,
            filter: Boolean,
            admin : Boolean
        },
        data() {
            return {
                checkBox : [],
                medicineList : [],
                medHubNm : ''
            }
        },
        watch : {
		    searchData(newValue) {
                console.log("변경 체크");
                //props 변경 여부 확인
                this.medHubNm = newValue;

            }
        },
        methods : {
            fn_search(){

                console.log("@@@@ this.searchData : %o",this.searchData);

                if(this.medHubNm == null || this.medHubNm == ''){
                    alert("약재명을 입력해주세요");
                    return;
                }

                let param = new Object();
                param.medHubNm = this.medHubNm;

                console.log("@@@@ param : %o",param);

                axios
                    .post("/api/modal/searchModalMedicine", param)
                    .then((res) => {
                        console.log("@@@@ dtl res : %o",res);
                        this.medicineList = res.data.medicineInfo;
                    })
                    .catch((err) => console.log(err));
                
            },
            fn_apply(){
                               
                if(this.checkBox.length == 0){
                    alert("체크된 약재가 없습니다.");
                }else if(this.checkBox.length > 1){
                    alert("한개 이상 선택할수 없습니다.");
                }else{                    
                    
                    let medObject = this.medicineList[this.checkBox[0]];
                    
                    //let medCode = this.medicineList[this.checkBox[0]].med_hrb_cd;
                    //let medName = this.medicineList[this.checkBox[0]].med_hrb_nm;
                    //let medHrbDtlSeq = this.medicineList[this.checkBox[0]].med_hrb_dtl_seq;
                    //let orgPlceNm = this.medicineList[this.checkBox[0]].org_plce_nm;


                    this.$emit('callback', medObject);

                    this.fn_init();
                    this.$bvModal.hide('medicineCompanySearch');
                }                                        
            },
            fn_init(){
                this.medicineList = [];
                this.checkBox = [];
                this.medHubNm = '';
            },
            fn_check(){
                if(this.checkBox.length > 1){
                    this.checkBox.splice(0,1);
                }
            }
        }
    }
</script>
